import { useParams } from 'react-router-dom';
import Description from 'src/components/description-block/description';
import PageHeader from 'src/components/page-header/page-header';
import { renderDateLong } from 'src/utils/date-time';
import { useGetNews } from './data/queries';
import css from './single-news.module.scss';
import { NEWS } from 'src/constants/routes';
import { useMetaContext } from 'src/hooks/meta-context';
import generalBannerSoldier from 'src/assets/general/general-banner-soldier.webp';

export default function SingleNews() {
  const { slug } = useParams();
  const { updateMetaInfo } = useMetaContext();
  const { data: news } = useGetNews(slug);
  const page = {
    path: NEWS.path,
    title: NEWS.title
  };

  news &&
    updateMetaInfo({
      title: NEWS.meta.title,
      description: NEWS.meta.description,
      openGraph: {
        title: news.title,
        description: news.shortDescription.replace(/<\/?[^>]+(>|$)/g, ''),
        img: news.imgUrl ?? generalBannerSoldier,
        type: 'website'
      }
    });

  return (
    <main className={css.newsPage}>
      <PageHeader title={news?.title ?? ''} description={''} pages={[page]} />
      <div className={css.container}>
        {news && (
          <div className={css.content}>
            <h1 className={css.newsTitle}>{news.title}</h1>
            <Description description={news.shortDescription} className={css.shortDescription} />

            <div className={css.publishedDate}>{renderDateLong(news.publishedAt)}</div>
            {news.imgUrl && (
              <div className={css.imageContainer}>
                <img src={news.imgUrl} alt={news.title} />
              </div>
            )}
            <Description description={news.detailedDescription} className={css.detailedDescription} />

            {news.tags.length > 0 && (
              <div className={css.tagsRow}>
                <h4 className={css.tagsRowTitle}>Теги:</h4>
                <div className={css.tagsRow}>
                  {news.tags.map((tag) => (
                    <p key={tag.id} className={css.tagBadge}>
                      {tag.name}
                    </p>
                  ))}
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </main>
  );
}
